export const FILTERS = [
  { labelKey: "candidatesPage.filters.all", value: "all" },
  { labelKey: "candidatesPage.filters.blacklisted", value: "blacklisted" },
  { labelKey: "candidatesPage.filters.blocked", value: "blocked" },
  { labelKey: "candidatesPage.filters.talentPool", value: "talent-pool" },
];

export const CANDIDATE_MODAL_KEYS = {
  NONE: "",
  SEND_EMAIL: "sendEmail",
  REQUEST_DOCUMENT: "requestDocument",
  BLACKLIST: "blacklist",
  BLOCKLIST: "blocklist",
  ADD_TALENT_POOL: "addTalentPool",
  DELETE_CANDIDATE: "deleteCandidate",
  VIEW_PROFILE: "viewProfile",
  COLUMNS: "columns",
  EXPORT: "export",
  SHARE_LINK: "shareLink",
  DELETE_CONFIRMATION: "deleteConfirmation",
  SHARE: "share",
  EMAIL: "email",
  WHATSAPP: "whatsapp",
  PHONE: "phone",
  EDIT: "edit",
  DELETE: "delete",
  CREATE_CANDIDATE: "createCandidate",
  MATCH_POSITION: "matchPosition",
  UNBLOCK_CONFIRMATION: "unblockConfirmation",
  UNBLACKLIST_CONFIRMATION: "unblacklistConfirmation",
  NEW_TALENT_POOL: "newTalentPool",
};

export const CANDIDATE_PROFILE_TABS = [
  { value: "details", label: "Details" },
  { value: "insights", label: "Insights" },
  { value: "experience", label: "Experience" },
  { value: "document", label: "Document" },
  { value: "history", label: "History" },
  { value: "archives", label: "Archives" },
  { value: "email", label: "Email" },
  { value: "chat", label: "Chat" },
];

// ============ Constant for Page Titles ============
export const CANDIDATE_PAGE_TITLES = {
  all: "Candidates Management",
  blocked: "Blocklist Candidates Management",
  blacklist: "Blacklist Candidates Management",
  "talent-pool": "Talent Pool Candidates Management",
};
//==========================
export const SOURCES = [
  { value: "linkedIn", en: "LinkedIn", ar: "لينكد إن", gr: "linkedIn" },
  { value: "indeed", en: "Indeed", ar: "إنديد", gr: "indeed" },
  { value: "wuzzuf", en: "Wuzzuf", ar: "وظف", gr: "wuzzuf" },
  { value: "bayt", en: "Bayt", ar: "Bayt", gr: "bayt" },
  { value: "facebook", en: "Facebook", ar: "فيسبوك", gr: "facebook" },
  {
    value: "careerSite",
    en: "Career site",
    ar: "موقع التوظيف",
    gr: "Karriere Seite",
  },
  {
    value: "talentAcquisitionDep",
    en: "Talent Acquisition Dep",
    ar: "الفريق الداخلي",
    gr: "Abteilung für Talentakquise",
  },
  {
    value: "recruitmentAgency",
    en: "Recruitment Agency",
    ar: "وكالة توظيف",
    gr: "Personal Agentur",
  },
  {
    value: "freelanceRecruiter",
    en: "Freelance Recruiter",
    ar: "المجند المستقل",
    gr: "Freiberuflicher Personalvermittler",
  },
  { value: "referral", en: "Referral", ar: "الإحالة", gr: "Verweisung" },
  { value: "other", en: "Other", ar: "آخر", gr: "Andere" },
  {
    value: "internal-hiring",
    en: "Internal Hiring",
    ar: "التوظيف الداخلي",
    gr: "interne Einstellung",
  },
];

export const BLOCK_REASONS = [
  { 
    value: 'unprofessional_communication',
    en: 'Unprofessional Communication',
    ar: 'تواصل غير مهني',
    gr: 'Unprofessionelle Kommunikation'
  },
  { 
    value: 'policy_violations',
    en: 'Policy Violations',
    ar: 'انتهاك السياسات',
    gr: 'Richtlinienverletzungen'
  },
  { 
    value: 'security_concerns',
    en: 'Security Concerns',
    ar: 'مخاوف أمنية',
    gr: 'Sicherheitsbedenken'
  },
  { 
    value: 'other',
    en: 'Other',
    ar: 'آخر',
    gr: 'Andere'
  }
]

export const BLACKLIST_REASONS = [
  { 
    value: 'no_show',
    en: 'No Show',
    ar: 'عدم الحضور',
    gr: 'Nicht erschienen'
  },
  { 
    value: 'inappropriate_behavior',
    en: 'Inappropriate Behavior',
    ar: 'سلوك غير لائق',
    gr: 'Unangemessenes Verhalten'
  },
  { 
    value: 'poor_performance',
    en: 'Poor Performance',
    ar: 'أداء ضعيف',
    gr: 'Schlechte Leistung'
  },
  { 
    value: 'other',
    en: 'Other',
    ar: 'آخر',
    gr: 'Andere'
  }
]